import React, { useState } from 'react';
import { AlignLeft, AlignCenter, AlignRight } from 'lucide-react';

interface TextBlockEditorProps {
  settings: any;
  content: any;
  onSettingsChange: (settings: any) => void;
  onContentChange: (content: any) => void;
}

const TextBlockEditor: React.FC<TextBlockEditorProps> = ({ 
  settings, 
  content, 
  onSettingsChange, 
  onContentChange 
}) => {
  const handleSettingChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value, type } = e.target;
    const newValue = type === 'checkbox' 
      ? (e.target as HTMLInputElement).checked 
      : type === 'number' 
        ? parseInt(value) 
        : value;
    
    onSettingsChange({ [name]: newValue });
  };
  
  const handleContentChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    onContentChange({ text: e.target.value });
  };
  
  const handleAlignmentChange = (alignment: 'left' | 'center' | 'right') => {
    onSettingsChange({ textAlign: alignment });
  };
  
  return (
    <div className="space-y-6">
      {/* General Settings */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-slate-700">Genel Ayarlar</h3>
        
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="block text-sm text-slate-600">
              Başlık
            </label>
            <input
              type="text"
              name="title"
              value={settings?.title || 'Metin Bloğu'}
              onChange={handleSettingChange}
              className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45]"
            />
          </div>
          
          <div className="flex items-end">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                name="showTitle"
                checked={settings?.showTitle !== false}
                onChange={handleSettingChange}
                className="rounded border-slate-300 text-[#F7BA45] focus:ring-[#F7BA45]"
              />
              <span className="text-sm text-slate-600">Başlığı Göster</span>
            </label>
          </div>
        </div>
        
        <div className="space-y-2">
          <label className="block text-sm text-slate-600">
            Metin Hizalama
          </label>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => handleAlignmentChange('left')}
              className={`p-2 rounded-lg ${
                settings?.textAlign === 'left' || !settings?.textAlign
                  ? 'bg-[#F7BA45]/10 text-[#F7BA45] border border-[#F7BA45]/20'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200 border border-transparent'
              }`}
            >
              <AlignLeft size={20} />
            </button>
            <button
              type="button"
              onClick={() => handleAlignmentChange('center')}
              className={`p-2 rounded-lg ${
                settings?.textAlign === 'center'
                  ? 'bg-[#F7BA45]/10 text-[#F7BA45] border border-[#F7BA45]/20'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200 border border-transparent'
              }`}
            >
              <AlignCenter size={20} />
            </button>
            <button
              type="button"
              onClick={() => handleAlignmentChange('right')}
              className={`p-2 rounded-lg ${
                settings?.textAlign === 'right'
                  ? 'bg-[#F7BA45]/10 text-[#F7BA45] border border-[#F7BA45]/20'
                  : 'bg-slate-100 text-slate-600 hover:bg-slate-200 border border-transparent'
              }`}
            >
              <AlignRight size={20} />
            </button>
          </div>
        </div>
      </div>
      
      {/* Content */}
      <div className="space-y-4">
        <h3 className="text-sm font-medium text-slate-700">İçerik</h3>
        
        <div className="space-y-2">
          <label className="block text-sm text-slate-600">
            HTML İçerik
          </label>
          <textarea
            value={content?.text || '<p>Buraya metin ekleyin...</p>'}
            onChange={handleContentChange}
            rows={8}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-[#F7BA45] focus:border-[#F7BA45] font-mono text-sm"
          />
          <p className="text-xs text-slate-500">
            HTML formatında içerik girebilirsiniz. Örneğin: &lt;p&gt;Paragraf&lt;/p&gt;, &lt;h2&gt;Başlık&lt;/h2&gt;, &lt;ul&gt;&lt;li&gt;Liste öğesi&lt;/li&gt;&lt;/ul&gt;
          </p>
        </div>
      </div>
    </div>
  );
};

export default TextBlockEditor;